(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const diamond = root.querySelector('[data-carat-diamond]');
    const selectedDiamond = root.querySelector('[data-selected-diamond]');
    const points = [...root.querySelectorAll('[data-carat-size]')];
    const shapes = [...root.querySelectorAll('[data-shape-image]')];
    points.forEach((point) => point.addEventListener('click', () => {
      diamond.style.setProperty('--diamond-size', `${point.dataset.caratSize}px`);
      points.forEach((item) => {
        const active = item === point;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    }));
    shapes.forEach((shape) => shape.addEventListener('click', () => {
      if (selectedDiamond) {
        selectedDiamond.src = shape.dataset.shapeImage;
        selectedDiamond.alt = `${shape.dataset.shapeName} colorless diamond`;
      }
      shapes.forEach((item) => {
        const active = item === shape;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    }));
  }
  document.querySelectorAll('[data-colorless-masterpieces]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-colorless-masterpieces]').forEach(init));
})();
